import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';import { AppService } from '../../../../app/app.service';
import { AddTrainingCategoryComponent } from '../add-training-category/add-training-category.component';
import { TrainingCategoriesVM, TrainingCatgoriesAndSections, TrainingVM } from '../setup-training-types.model';
import { TrainingService } from '../training.service';

@Component({
  selector: 'app-setup-training-types',
  templateUrl: './setup-training-types.component.html',
  styleUrls: ['./setup-training-types.component.scss']
})
export class SetupTrainingTypesComponent implements OnInit {

  TrainingTypesAndSections:TrainingCatgoriesAndSections 
  trainingMainCategories :TrainingCategoriesVM[];
  trainingCategories :TrainingCategoriesVM[];

  trainingSections:TrainingCategoriesVM[];
  trainings:TrainingVM[];
  constructor(private _dialog: MatDialog,
    private _appService: AppService, private  _trainingService: TrainingService, ) { }

  ngOnInit() {
    console.log("loadddd____")
    this._appService.setPageTitle('Setup Training Types and Sections ');
    this.LoadCatgoriesAndSections();

  }


  LoadCatgoriesAndSections(){
    this._trainingService.GetTrainingTypesAndSections().subscribe(res=>{
      console.log("resulr__", res)
      this.TrainingTypesAndSections = res;
      this.trainingMainCategories = this.TrainingTypesAndSections.MainParentCategories;
      this.trainingCategories=this.TrainingTypesAndSections.ParentCategories;
      this.trainingSections= this.TrainingTypesAndSections.CategorySections;
      this.trainings =  this.TrainingTypesAndSections.Trainings;
    })
  }

  OpenAddMainCategory( ) {
    const addCategoeynDialog = this._dialog.open(AddTrainingCategoryComponent, {
      data: {
        isMainCategoery:true,
      }
    });
    addCategoeynDialog.afterClosed().subscribe(details => {
      if (details ==true) {
        this.LoadCatgoriesAndSections();
      }
    });
  }

  OpenEditMainCategory(catId:number,Name:string){
    const addSectionDialog = this._dialog.open(AddTrainingCategoryComponent, {
      
      data: {
        sectionId: catId,
        Name:Name,
        isMainCategoeryEdit:true,
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details ==true) {
        this.LoadCatgoriesAndSections();
      }
    });
  }
  OpenAddCategory( MainparentCatId: number) {
    const addCategoeynDialog = this._dialog.open(AddTrainingCategoryComponent, {
      data: {
        MainparentCatId: MainparentCatId,
        isCategoery:true,
      }
    });
    addCategoeynDialog.afterClosed().subscribe(details => {
      if (details ==true) {
        this.LoadCatgoriesAndSections();
      }
    });
  }

  OpenEditCategory(catId:number, isParent:boolean,Name:string){
    const addSectionDialog = this._dialog.open(AddTrainingCategoryComponent, {
      
      data: {
        sectionId: catId,
        isSection:false,
        isCategoeryEdit:true,
        isParent:isParent,
        Name:Name,
        isUpdateCat:0,
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details ==true) {
        this.LoadCatgoriesAndSections();
      }
    });
  }

  OpenAddSection(parentCatId: number) {
    const addSectionDialog = this._dialog.open(AddTrainingCategoryComponent, {
      data: {
        parentCatId: parentCatId,
        isSection:true,
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details ==true) {
        this.LoadCatgoriesAndSections();
      }
    });
  }

  OpenAddTraining(parentCatId: number){
    const addSectionDialog = this._dialog.open(AddTrainingCategoryComponent, {
      data: {
        parentCatId: parentCatId,
        isTraining:true,
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details ==true) {
        this.LoadCatgoriesAndSections();
      }
    });
  }

  OpenEditTraining(traingId:number, isParent:boolean,Name:string){
    const addSectionDialog = this._dialog.open(AddTrainingCategoryComponent, {
      
      data: {
        sectionId: traingId,
        isSection:false,
        isCategoeryEdit:false,
        isTrainingEdit:true,
        Name:Name,
        isUpdateCat:0,
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details ==true) {
        this.LoadCatgoriesAndSections();
      }
    });
  }

  OrderUP_MC(order:number){
    this._trainingService.OrderUp_MainCategories(order).subscribe(res=>{
      this.LoadCatgoriesAndSections();
    })
  }
  OrderDown_MC(order:number){
    this._trainingService.OrderDown_MainCategories(order).subscribe(res=>{
      this.LoadCatgoriesAndSections();
    })
  }
  OrderUP_C(order:number,parentId:number){
    this._trainingService.OrderUp_Categories(order,parentId).subscribe(res=>{
      this.LoadCatgoriesAndSections();
    })
  }
  OrderDown_C(order:number,parentId:number){
    this._trainingService.OrderDown_Categories(order,parentId).subscribe(res=>{
      this.LoadCatgoriesAndSections();
    })
  }

  OrderUP_S(order:number, parentId:number){
    this._trainingService.OrderUp_Section(order,parentId).subscribe(res=>{
      this.LoadCatgoriesAndSections();
    })
  }
  OrderDown_S(order:number, parentId:number){
    this._trainingService.OrderDown_Section(order,parentId).subscribe(res=>{
      this.LoadCatgoriesAndSections();
    })
  }

  
  OrderUP_T(order:number, parentId:number){
    this._trainingService.OrderUp_Training(order,parentId).subscribe(res=>{
      this.LoadCatgoriesAndSections();
    })
  }
  OrderDown_T(order:number, parentId:number){
    this._trainingService.OrderDown_Training(order,parentId).subscribe(res=>{
      this.LoadCatgoriesAndSections();
    })
  }

  toggleCategoryActive(catId:number, Active:boolean){
    this._trainingService.TogglelTrainigTypesCategory(catId,Active).subscribe(res=>{
      this.LoadCatgoriesAndSections();
    })
  }
  toggleMainCategoryActive(catId:number, Active:boolean){
    this._trainingService.TogglelMainTrainigTypesCategory(catId,Active).subscribe(res=>{
      this.LoadCatgoriesAndSections();
    })
  }

  toggleTrainingActive(catId:number, Active:boolean){
    this._trainingService.TogglelTrainings(catId,Active).subscribe(res=>{
      this.LoadCatgoriesAndSections();
    })
  }
  
}
